import { IconBaseType } from "@/v2-components/core/icon/type";
import { cn } from "@/libs/utils";

export default function ShoppingBagIcon({ className }: IconBaseType) {
  return (
    <svg
      className={cn("size-6", className)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_22605_29007)">
        <mask
          id="mask0_22605_29007"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <rect width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_22605_29007)">
          <path
            d="M5.30775 21.5C4.80908 21.5 4.38308 21.3234 4.02975 20.9703C3.67658 20.6169 3.5 20.1909 3.5 19.6923V8.30775C3.5 7.80908 3.67658 7.38308 4.02975 7.02975C4.38308 6.67658 4.80908 6.5 5.30775 6.5H7.5C7.5 5.25133 7.93783 4.18917 8.8135 3.3135C9.68917 2.43783 10.7513 2 12 2C13.2487 2 14.3108 2.43783 15.1865 3.3135C16.0622 4.18917 16.5 5.25133 16.5 6.5H18.6923C19.1909 6.5 19.6169 6.67658 19.9703 7.02975C20.3234 7.38308 20.5 7.80908 20.5 8.30775V19.6923C20.5 20.1909 20.3234 20.6169 19.9703 20.9703C19.6169 21.3234 19.1909 21.5 18.6923 21.5H5.30775ZM5.30775 20H18.6923C18.7692 20 18.8398 19.9679 18.9038 19.9038C18.9679 19.8398 19 19.7693 19 19.6923V8.30775C19 8.23075 18.9679 8.16025 18.9038 8.09625C18.8398 8.03208 18.7692 8 18.6923 8H5.30775C5.23075 8 5.16025 8.03208 5.09625 8.09625C5.03208 8.16025 5 8.23075 5 8.30775V19.6923C5 19.7693 5.03208 19.8398 5.09625 19.9038C5.16025 19.9679 5.23075 20 5.30775 20ZM12 13.5C13.2487 13.5 14.3108 13.0622 15.1865 12.1865C16.0622 11.3108 16.5 10.2487 16.5 9H15C15 9.83333 14.7083 10.5417 14.125 11.125C13.5417 11.7083 12.8333 12 12 12C11.1667 12 10.4583 11.7083 9.875 11.125C9.29167 10.5417 9 9.83333 9 9H7.5C7.5 10.2487 7.93783 11.3108 8.8135 12.1865C9.68917 13.0622 10.7513 13.5 12 13.5ZM9 6.5H15C15 5.66667 14.7083 4.95833 14.125 4.375C13.5417 3.79167 12.8333 3.5 12 3.5C11.1667 3.5 10.4583 3.79167 9.875 4.375C9.29167 4.95833 9 5.66667 9 6.5Z"
            fill="#1C1B1F"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_22605_29007">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
